
import { defineComponent } from "vue";
import Sidebar from "primevue/sidebar";
import OverlayPanel from "primevue/overlaypanel";
import firebase from "@/firebase/firebase";

export default defineComponent({
  name: "Header",
  components: {
    Sidebar,
    OverlayPanel,
  },
  data() {
    return {
      visibleMenu: false,
      visibleUser: false,
      isLogin: false,
    };
  },
  methods: {
    menuOn() {
      this.visibleMenu = true;
    },
    userOn() {
      // eslint-disable-next-line
      const tmp = this.$refs.op as any;
      tmp.toggle(event);
    },
    signOut: async function () {
      await firebase.auth().signOut();

      console.log("signout");
      this.userOn();
    },
    checkLogin() {
      this.isLogin = firebase.auth().currentUser != null;
    },
  },
});
